import React from 'react';
import './WhyChoose.css';

const WhyChoose = ({ t }) => {
  const features = [
    {
      image: '/images/goree.jpg',
      title: t.features[0].title,
      text: t.features[0].text,
      number: '01'
    },
    {
      image: '/images/saintlouis.jpg',
      title: t.features[1].title,
      text: t.features[1].text,
      number: '02'
    },
    {
      image: '/images/20240504_095708.jpg',
      title: t.features[2].title,
      text: t.features[2].text,
      number: '03'
    },
    {
      image: '/images/lacrose.jpg',
      title: t.features[3].title,
      text: t.features[3].text,
      number: '04'
    }
  ];

  return (
    <section className="why-choose">
      <div className="container">
        <div className="why-header">
          <span className="section-tag">{t.tag}</span>
          <h2 className="section-title">{t.title.replace('\n', ' ')}</h2>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className={`feature-box feature-${index + 1}`}>
              <div className="feature-image">
                <img src={`${process.env.PUBLIC_URL}${feature.image}`} alt={feature.title} />
                <div className="feature-overlay">
                  <span className="feature-number">{feature.number}</span>
                </div>
              </div>
              <div className="feature-content">
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
